module.exports = __webpack_public_path__ + "img/video-1.e39c229b.jpg";